import { IMasterclassDescription } from '@/interfaces/masterclassDescription';
import useMasterclassDescriptionStore from '@/store/MasterClassDescription/useMasterclasDescriptionStore';
import { Container, Slider } from '@pwskills/rachnaui';
import CoursesCard from '@/components/common/CoursesCard';
import { ICourses } from '@/interfaces/homePage';
import { useRef } from 'react';
import { classNames } from '@pwskills/rachnaui/utils';
import { useRouter } from 'next/router';
import RecommendedCoursesCard from '@/components/PostLoginOnboarding/RecommendedCoursesCard';
import MasterclassHeader from '../MasterclassHeader';

const RelatedCoursesSection = () => {
  const masterclassDetails = useMasterclassDescriptionStore(
    (state: { masterclassDetails: IMasterclassDescription }) => state.masterclassDetails
  );
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  const sliderRef = useRef<null | HTMLDivElement>(null);
  const { relatedCourses, slug, title } = masterclassDetails || {};

  return (
    <div className="w-full bg-blue-50">
      <Container
        id="category-hero-section"
        className="!py-8 medium:!pt-14 medium:!pb-8 large:!pt-[56px] large:!pb-6 flex flex-col !px-8 large:!px-20"
      >
        <MasterclassHeader
          headerText="Related Courses"
          className={classNames(isDashboard ? 'text-left' : 'text-center')}
        />
        <div ref={sliderRef}>
          <Slider
            iconWrapperClass="top-[8rem]"
            className={classNames(
              '!gap-2 medium:!gap-x-[22px] [&>div]:mr-2 [&>*:last-child]:mr-0 !mx-auto [&>div]:large:ml-4 !pt-4 !pl-2'
            )}
            wrapperClass="mt-6"
            positionOfSliderInMobile="bottom"
          >
            {relatedCourses?.map((course: ICourses, index: number) => {
              const singleObj: any = {
                title: course.title,
                image: course.img,
                duration: '',
                enrollmentCount: '',
              };
              //             pricing: Pricing;
              // enrollmentCount: number;
              // _id: string;
              // courseType: string;
              // hashTag: string;
              // title: string;
              // slug: string;
              // img: string;
              // courseMeta: CourseMeta;
              // url: string;
              // registration: {
              //   startDate: string;
              // };
              // isPremiumOnlineDegreeCourse: boolean;
              // partnerInstitute: {
              //   _id: string;
              //   subDomain: string;
              // };
              return isDashboard ? (
                <RecommendedCoursesCard cardInfo={singleObj} cardPosition={index + 1} />
              ) : (
                <CoursesCard
                  course={course}
                  pageFrom="masterclass_description_page"
                  key={course._id}
                  section="masterclass_description"
                  position="masterclass_description_related_courses"
                  masterclassSlug={slug}
                  masterClassTitle={title}
                  cardPosition={index + 1}
                />
              );
            })}
          </Slider>
        </div>
      </Container>
    </div>
  );
};

export default RelatedCoursesSection;
